import { Quaternion, QuaternionLinearInterpolant } from 'three';

import { KeyframeTrack, KeyframeTrackData } from './KeyframeTrack';

/**
 * A Track of quaternion keyframe values.
 */
export class QuaternionKeyframeTrack extends KeyframeTrack {
  valueTypeName = 'quaternion';

  constructor(
    name: string,
    times: Array<number>,
    values: Array<Quaternion>,
    interpolation?: number,
  ) {
    super(name, times, values, interpolation);
  }

  InterpolantFactoryMethodLinear(result: any): QuaternionLinearInterpolant {
    return new QuaternionLinearInterpolant(
      this.times,
      this.values,
      this.getValueSize(),
      result,
    );
  }

  static parse(json: KeyframeTrackData): QuaternionKeyframeTrack {
    return new QuaternionKeyframeTrack(
      json.name,
      json.times,
      (json.values as number[][]).map(
        (value: number[]) => new Quaternion(...value),
      ),
      json.interpolation,
    );
  }
}
